import { render, staticRenderFns } from "./CommentModule.vue?vue&type=template&id=19830951&"
import script from "./CommentModule.vue?vue&type=script&lang=js&"
export * from "./CommentModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports